import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../config";
import useStyleSheet from "../useStyleSheet";
import MarketingTopNav from "../components/MarketingTopNav";
import "./buzz.css";

// Hero animation: QR → κινητό που το «φωτογραφίζει» (φλας + το QR εμφανίζεται
// στην οθόνη του) → καμπανάκι που ταλαντεύεται κρεμασμένο. Χορογραφία ~9s με
// CSS keyframes στο buzz.css (.bq*) — διαδοχικά ανά ~3s, σέβεται reduced-motion.
function BuzzHeroIcons() {
  return (
    <div className="bqRow" aria-hidden="true">
      {/* QR code */}
      <svg className="bqIcon bqQr" viewBox="0 0 64 64" width="54" height="54">
        <rect x="2" y="2" width="60" height="60" rx="10" fill="#fff" stroke="#e5e7eb" strokeWidth="2" />
        {/* finder patterns */}
        <g fill="#111827">
          <path d="M10 10h16v16H10z M14 14v8h8v-8z" fillRule="evenodd" />
          <path d="M38 10h16v16H38z M42 14v8h8v-8z" fillRule="evenodd" />
          <path d="M10 38h16v16H10z M14 42v8h8v-8z" fillRule="evenodd" />
          <rect x="17" y="17" width="2" height="2" fill="none" />
        </g>
        <g fill="#d97706">
          <rect x="17" y="17" width="2" height="2" /><rect x="45" y="17" width="2" height="2" /><rect x="17" y="45" width="2" height="2" />
        </g>
        {/* data modules */}
        <g fill="#111827">
          <rect x="32" y="12" width="3" height="3" /><rect x="32" y="20" width="3" height="3" />
          <rect x="12" y="31" width="3" height="3" /><rect x="20" y="31" width="3" height="3" /><rect x="28" y="31" width="3" height="3" />
          <rect x="38" y="32" width="3" height="3" /><rect x="46" y="36" width="3" height="3" /><rect x="52" y="30" width="3" height="3" />
          <rect x="34" y="40" width="3" height="3" /><rect x="42" y="44" width="3" height="3" /><rect x="52" y="42" width="3" height="3" />
          <rect x="32" y="52" width="3" height="3" /><rect x="40" y="52" width="3" height="3" /><rect x="48" y="52" width="4" height="4" fill="#d97706" />
        </g>
      </svg>

      {/* Κινητό με κάμερα/viewfinder */}
      <svg className="bqIcon bqPhone" viewBox="0 0 64 64" width="62" height="62">
        <rect x="16" y="4" width="32" height="56" rx="7" fill="#111827" />
        <rect x="19" y="10" width="26" height="42" rx="3" fill="#f8fafc" />
        <circle cx="32" cy="7.2" r="1.4" fill="#475569" /> {/* κάμερα */}
        <rect x="27" y="55" width="10" height="2.4" rx="1.2" fill="#475569" />
        {/* viewfinder γωνίες */}
        <g stroke="#d97706" strokeWidth="2" fill="none" strokeLinecap="round">
          <path d="M23 18v-4h4" /><path d="M41 14h-4" transform="translate(0 0)" /><path d="M41 14v4" />
          <path d="M23 44v4h4" /><path d="M41 48h-4" /><path d="M41 48v-4" />
        </g>
        {/* το «τραβηγμένο» QR — εμφανίζεται με το φλας */}
        <g className="bqShot">
          <rect x="24" y="21" width="16" height="16" rx="2" fill="#fff" stroke="#e5e7eb" strokeWidth="0.8" />
          <g fill="#111827">
            <rect x="26" y="23" width="4.4" height="4.4" /><rect x="33.6" y="23" width="4.4" height="4.4" />
            <rect x="26" y="30.6" width="4.4" height="4.4" />
            <rect x="32.6" y="30.6" width="2.2" height="2.2" /><rect x="35.4" y="33.4" width="2.2" height="2.2" fill="#d97706" />
          </g>
        </g>
        {/* φλας */}
        <circle className="bqFlash" cx="32" cy="31" r="26" fill="url(#bqFlashGrad)" />
        <defs>
          <radialGradient id="bqFlashGrad">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="1" />
            <stop offset="55%" stopColor="#ffffff" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="bqBellGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="60%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
      </svg>

      {/* Καμπανάκι — κρεμασμένο, ταλαντεύεται με σταθερό το πάνω μέρος */}
      <span className="bqBellWrap">
        <svg className="bqIcon" viewBox="0 0 64 64" width="62" height="62">
          {/* ηχητικά κύματα */}
          <g className="bqWaves" stroke="#f59e0b" strokeWidth="2.5" fill="none" strokeLinecap="round">
            <path d="M10 26c-3 4-3 10 0 14" /><path d="M54 26c3 4 3 10 0 14" />
            <path d="M5 22c-5 6-5 16 0 22" opacity="0.5" /><path d="M59 22c5 6 5 16 0 22" opacity="0.5" />
          </g>
          <circle cx="32" cy="6.5" r="3" fill="none" stroke="#b45309" strokeWidth="2.5" />
          <path d="M32 10c-9 0-14 6.5-14.8 14.5-.5 5.5-1.6 10.5-4.7 14-1.2 1.4-.3 3.5 1.6 3.5h35.8c1.9 0 2.8-2.1 1.6-3.5-3.1-3.5-4.2-8.5-4.7-14C46 16.5 41 10 32 10z"
            fill="url(#bqBellGrad)" stroke="#b45309" strokeWidth="1.5" />
          <path d="M27 47a5 5 0 0 0 10 0" fill="#b45309" />
          <circle className="bqClapper" cx="32" cy="49.5" r="3.4" fill="#92400e" />
        </svg>
      </span>
    </div>
  );
}

// Το QR εικονίδιο της υπηρεσίας (ίδιο με το ReservationsList, δίπλα στα
// άλλα action icons) — δεν υπάρχει QR emoji, οπότε κοινό SVG παντού.
function QrGlyph({ size = 36 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      style={{ fill: "#444", display: "inline-block", verticalAlign: "middle" }}
    >
      <path d="M3 3h8v8H3V3zm2 2v4h4V5H5z" />
      <path d="M13 3h8v8h-8V3zm2 2v4h4V5h-4z" />
      <path d="M3 13h8v8H3v-8zm2 2v4h4v-4H5z" />
      <path d="M13 13h2v2h-2v-2zm3 0h2v3h-2v-3zm3 0h2v2h-2v-2z" />
      <path d="M13 16h3v2h-3v-2zm4 1h2v2h-2v-2z" />
      <path d="M19 16h2v5h-5v-2h3v-3z" />
      <path d="M13 19h2v2h-2v-2z" />
    </svg>
  );
}

// Ετικέτες του κοινού MarketingTopNav (το BuzzLanding δεν έχει i18n bootstrap).
const NAV_LABELS = {
  el: { "nav.features": "Δυνατότητες", "nav.how": "Πώς δουλεύει", "nav.pricing": "Τιμές", "nav.faq": "Συχνές ερωτήσεις", "nav.signin": "Σύνδεση", "nav.contact": "Επικοινωνία" },
  en: { "nav.features": "Features", "nav.how": "How it works", "nav.pricing": "Pricing", "nav.faq": "FAQ", "nav.signin": "Sign in", "nav.contact": "Contact" },
};

// Δίγλωσσο inline dictionary (ίδια φιλοσοφία με το MarketingHome — η landing
// πρέπει να δουλεύει και για μη συνδεδεμένους χωρίς i18n bootstrap).
const COPY = {
  el: {
    title: "Κλήση σερβιτόρου με ένα QR",
    subtitle: "Ο πελάτης σκανάρει, πατάει ένα κουμπί — το προσωπικό σου ειδοποιείται αμέσως στο κινητό του. Στήσιμο σε 5 λεπτά, χωρίς εξοπλισμό.",
    cta: "Ξεκίνα δωρεάν δοκιμή 15 ημερών",
    ctaHint: "Χρειάζεται κάρτα για επαλήθευση — καμία χρέωση στη δοκιμή, ακύρωση με ένα κλικ.",
    howTitle: "Πώς δουλεύει",
    how: [
      ["qr", "Δίνεις το QR στην παρέα", "Εφήμερο QR ανά παρέα ή κράτηση, που λήγει μόνο του όταν φύγουν — ή, αν προτιμάς, μόνιμα QR στα τραπέζια από έτοιμο PDF."],
      ["📲", "Ο πελάτης σκανάρει", "Χωρίς app, χωρίς εγγραφή. Πατάει «Κλήση», «Λογαριασμό» ή γράφει μήνυμα — και βλέπει live ότι έρχεστε."],
      ["🔔", "Εσείς ειδοποιείστε", "Push στο κινητό/ρολόι του σωστού σερβιτόρου (ανά ζώνη) + πίνακας κλήσεων με χρονόμετρα."],
    ],
    featTitle: "Ό,τι χρειάζεσαι — τίποτα περιττό",
    feats: [
      ["🗺 Ζώνες", "Σάλα, αυλή, παραλία — κάθε σερβιτόρος βλέπει και ειδοποιείται μόνο για τα δικά του τραπέζια."],
      ["⭐ Αξιολογήσεις", "Feedback μετά την εξυπηρέτηση. Οι 5άστεροι πελάτες οδηγούνται σε Google review."],
      ["📊 Αναφορές", "Χρόνοι απόκρισης, χαμένες κλήσεις ανά ώρα και ζώνη — δες πού χάνεις πελάτες."],
      ["⚡ Χωρίς εξοπλισμό", "Δουλεύει με τα κινητά που ήδη έχετε. Τίποτα να αγοράσεις, τίποτα να χαλάσει."],
      ["⏱ Χρονόμετρα στο πάσο", "Κάθε κλήση με μετρητή χρόνου και χρωματική κλιμάκωση — καμία παραγγελία δεν ξεχνιέται."],
      ["🌍 Δίγλωσσο για πελάτες", "Η σελίδα του πελάτη σε ελληνικά και αγγλικά αυτόματα — ιδανικό για τουριστικά μαγαζιά."],
    ],
    priceTitle: "Απλή τιμολόγηση",
    tables: "τραπέζια",
    perMonth: "/μήνα",
    perYear: "/έτος",
    yearlyBonus: "2 μήνες δώρο",
    minNote: "Ελάχιστη χρέωση: 5 τραπέζια.",
    monthly: "Μηνιαία",
    yearly: "Ετήσια",
    leadTitle: "Θες να σου το στήσουμε εμείς;",
    leadSub: "Άφησε τηλέφωνο και θα σε πάρουμε.",
    leadName: "Όνομα",
    leadPhone: "Τηλέφωνο",
    leadSend: "Στείλε",
    leadOk: "Ευχαριστούμε! Θα επικοινωνήσουμε σύντομα. 🤝",
    login: "Σύνδεση",
    faqTitle: "Συχνές ερωτήσεις",
    faq: [
      ["Χρειάζεται ο πελάτης να κατεβάσει κάτι;", "Όχι. Σκανάρει το QR με την κάμερα και ανοίγει μια απλή σελίδα — δουλεύει σε κάθε κινητό."],
      ["Τι γίνεται αν πατάει συνέχεια το κουμπί;", "Υπάρχει έξυπνο όριο: μία ανοιχτή κλήση ανά τραπέζι και χρόνος αναμονής μεταξύ κλήσεων — καμία «βροχή» ειδοποιήσεων."],
      ["Μπορώ να το ακυρώσω;", "Οποιαδήποτε στιγμή, με ένα κλικ, μέσα από τη σελίδα Συνδρομή."],
      ["Έχετε και σύστημα κρατήσεων ή παραγγελιοληψίας;", "Ναι — το EstiaSync είναι πλήρης πλατφόρμα εστίασης. Το Buzz είναι ο ευκολότερος τρόπος να ξεκινήσεις."],
    ],
  },
  en: {
    title: "Waiter call with a single QR",
    subtitle: "Guests scan, tap a button — your staff gets notified instantly on their phone. Set up in 5 minutes, no hardware.",
    cta: "Start your 15-day free trial",
    ctaHint: "A card is needed for verification — no charge during the trial, cancel with one click.",
    howTitle: "How it works",
    how: [
      ["qr", "Hand a QR to the party", "A temporary QR per party or reservation that expires on its own — or, if you prefer, permanent table QRs from a print-ready PDF."],
      ["📲", "Guests scan", "No app, no signup. They tap “Call”, “Bill” or type a message — and see live that you're coming."],
      ["🔔", "You get notified", "Push to the right waiter's phone/watch (per zone) + a call board with timers."],
    ],
    featTitle: "Everything you need — nothing you don't",
    feats: [
      ["🗺 Zones", "Hall, garden, beach — each waiter sees and gets notified only for their own tables."],
      ["⭐ Reviews", "Feedback after service. Five-star guests are guided to a Google review."],
      ["📊 Reports", "Response times, missed calls per hour and zone — see where you lose customers."],
      ["⚡ No hardware", "Works with the phones you already have. Nothing to buy, nothing to break."],
      ["⏱ Timers on the pass", "Every call gets a running timer with color escalation — nothing gets forgotten."],
      ["🌍 Bilingual for guests", "The guest page switches between Greek and English automatically — ideal for tourist spots."],
    ],
    priceTitle: "Simple pricing",
    tables: "tables",
    perMonth: "/month",
    perYear: "/year",
    yearlyBonus: "2 months free",
    minNote: "Minimum billed: 5 tables.",
    monthly: "Monthly",
    yearly: "Yearly",
    leadTitle: "Want us to set it up for you?",
    leadSub: "Leave your phone and we'll call you.",
    leadName: "Name",
    leadPhone: "Phone",
    leadSend: "Send",
    leadOk: "Thank you! We'll be in touch soon. 🤝",
    login: "Log in",
    faqTitle: "FAQ",
    faq: [
      ["Do guests need to install anything?", "No. They scan the QR with their camera and a simple page opens — works on every phone."],
      ["What if someone keeps tapping the button?", "Smart limits: one open call per table and a cooldown between calls — no notification storms."],
      ["Can I cancel?", "Any time, with one click, from the Billing page."],
      ["Do you also offer reservations or ordering?", "Yes — EstiaSync is a full hospitality platform. Buzz is the easiest way to start."],
    ],
  },
};

export default function BuzzLanding() {
  const [lang, setLang] = useState(
    (localStorage.getItem("buzz_landing_lang")) ||
    (navigator.language?.startsWith("el") ? "el" : "en")
  );
  const [tables, setTables] = useState(12);
  const [period, setPeriod] = useState("yearly");
  const [lead, setLead] = useState({ name: "", phone: "" });
  const [leadState, setLeadState] = useState(null);
  const t = COPY[lang];

  const billed = Math.max(5, tables);
  const monthly = (billed * 0.3).toFixed(2);
  const yearly = (billed * 3).toFixed(2);

  const switchLang = (l) => { setLang(l); localStorage.setItem("buzz_landing_lang", l); };

  // Ό,τι διάλεξε στον υπολογιστή τιμής (τραπέζια, μηνιαία/ετήσια) ταξιδεύει
  // στο billing μετά την εγγραφή — αποθήκευση στο κλικ κάθε CTA.
  const savePref = () => {
    try { localStorage.setItem("buzz_signup_pref", JSON.stringify({ tables, period })); } catch {}
  };
  const navT = (k) => NAV_LABELS[lang][k] || k;

  useStyleSheet("/marketing.css"); // Tailwind utilities του κοινού header

  // SPA πλοήγηση (π.χ. «Μάθε περισσότερα» από το promo) κρατά το scroll της
  // προηγούμενης σελίδας — η landing πρέπει να ανοίγει πάντα από την κορυφή.
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const sendLead = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${config.API_BASE_URL}/public/buzz/lead`, lead, { withCredentials: false });
      setLeadState("ok");
    } catch {
      setLeadState("err");
    }
  };

  const S = {
    section: { maxWidth: 900, margin: "0 auto", padding: "36px 20px", scrollMarginTop: 88 },
    h2: { fontSize: 26, marginBottom: 18, textAlign: "center" },
  };

  return (
    <div id="marketing-root" style={{ background: "#faf9f6", minHeight: "100vh", color: "#111827" }}>
      {/* Κοινό sticky header με το υπόλοιπο marketing site (γλώσσες, επικοινωνία, σύνδεση) */}
      <MarketingTopNav t={navT} lang={lang} setLanguage={switchLang} />

      {/* Hero */}
      <div style={{ ...S.section, textAlign: "center", paddingTop: 46 }}>
        <BuzzHeroIcons />
        <h1 style={{ fontSize: 36, margin: "12px 0" }}>{t.title}</h1>
        <p style={{ fontSize: 17, color: "#4b5563", maxWidth: 560, margin: "0 auto 24px" }}>{t.subtitle}</p>
        <Link to="/buzz-qr/register" onClick={savePref}>
          <button className="bz-btn primary" style={{ fontSize: 17, padding: "14px 28px" }}>{t.cta}</button>
        </Link>
        <p className="bz-hint" style={{ marginTop: 10 }}>{t.ctaHint}</p>
      </div>

      {/* How it works */}
      <div id="how" style={S.section}>
        <h2 style={S.h2}>{t.howTitle}</h2>
        <div className="bz-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))" }}>
          {t.how.map(([icon, title, body], i) => (
            <div key={i} className="bz-card" style={{ marginBottom: 0, textAlign: "center" }}>
              <div style={{ fontSize: 34, lineHeight: "40px" }}>{icon === "qr" ? <QrGlyph /> : icon}</div>
              <h4 style={{ margin: "8px 0" }}>{i + 1}. {title}</h4>
              <p className="bz-hint">{body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div id="features" style={S.section}>
        <h2 style={S.h2}>{t.featTitle}</h2>
        <div className="bz-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
          {t.feats.map(([title, body], i) => (
            <div key={i} className="bz-card" style={{ marginBottom: 0 }}>
              <h4 style={{ marginBottom: 6 }}>{title}</h4>
              <p className="bz-hint">{body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Pricing calculator */}
      <div id="pricing" style={S.section}>
        <h2 style={S.h2}>{t.priceTitle}</h2>
        <div className="bz-card" style={{ maxWidth: 520, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 40, fontWeight: 800 }}>{tables} <span style={{ fontSize: 18, fontWeight: 400 }}>{t.tables}</span></div>
          <input type="range" min="1" max="300" value={tables} style={{ width: "100%", margin: "14px 0", accentColor: "#d97706" }}
            onChange={e => setTables(Number(e.target.value))} />
          <div style={{ display: "flex", gap: 10, justifyContent: "center", margin: "10px 0 16px" }}>
            <button className={`bz-btn ${period === "monthly" ? "primary" : ""}`} onClick={() => setPeriod("monthly")}>{t.monthly}</button>
            <button className={`bz-btn ${period === "yearly" ? "primary" : ""}`} onClick={() => setPeriod("yearly")}>
              {t.yearly} <span style={{ fontSize: 11 }}>({t.yearlyBonus})</span>
            </button>
          </div>
          <div style={{ fontSize: 42, fontWeight: 800, color: "#d97706" }}>
            {period === "monthly" ? monthly : yearly} €
            <span style={{ fontSize: 16, color: "#6b7280", fontWeight: 400 }}>
              {period === "monthly" ? t.perMonth : t.perYear}
            </span>
          </div>
          <p className="bz-hint">
            {billed} {t.tables} × {period === "monthly" ? "0,30 €" : "3 €"} · {t.minNote}
          </p>
          <Link to="/buzz-qr/register" onClick={savePref}>
            <button className="bz-btn primary" style={{ marginTop: 10, padding: "12px 24px" }}>{t.cta}</button>
          </Link>
        </div>
      </div>

      {/* FAQ */}
      <div id="faq" style={S.section}>
        <h2 style={S.h2}>{t.faqTitle}</h2>
        <div style={{ maxWidth: 640, margin: "0 auto" }}>
          {t.faq.map(([q, a], i) => (
            <details key={i} className="bz-card" style={{ marginBottom: 10, cursor: "pointer" }}>
              <summary style={{ fontWeight: 600 }}>{q}</summary>
              <p className="bz-hint" style={{ marginTop: 8 }}>{a}</p>
            </details>
          ))}
        </div>
      </div>

      {/* Lead form */}
      <div style={{ ...S.section, paddingBottom: 60 }}>
        <div className="bz-card" style={{ maxWidth: 460, margin: "0 auto", textAlign: "center", borderLeft: "4px solid #d97706" }}>
          <h3>{t.leadTitle}</h3>
          <p className="bz-hint" style={{ marginBottom: 12 }}>{t.leadSub}</p>
          {leadState === "ok" ? (
            <div className="bz-banner" style={{ background: "#ecfdf3", borderColor: "#a7f3d0", color: "#065f46" }}>{t.leadOk}</div>
          ) : (
            <form onSubmit={sendLead} style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
              <input type="text" required placeholder={t.leadName} value={lead.name}
                style={{ border: "1px solid #d1d5db", borderRadius: 10, padding: "11px 12px", flex: "1 1 140px" }}
                onChange={e => setLead({ ...lead, name: e.target.value })} />
              <input type="tel" required placeholder={t.leadPhone} value={lead.phone}
                style={{ border: "1px solid #d1d5db", borderRadius: 10, padding: "11px 12px", flex: "1 1 140px" }}
                onChange={e => setLead({ ...lead, phone: e.target.value })} />
              <button className="bz-btn primary" type="submit">{t.leadSend}</button>
            </form>
          )}
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "20px 0 40px", color: "#9ca3af", fontSize: 13 }}>
        <a href="https://estiasync.com" style={{ color: "#9ca3af" }}>estiasync.com</a> — reservations · kitchen · ordering · buzz
        <div style={{ marginTop: 6 }}>
          <a href="/api/public/legal/terms" target="_blank" rel="noreferrer" style={{ color: "#9ca3af" }}>{lang === "el" ? "Όροι" : "Terms"}</a>
          {" · "}
          <a href="/api/public/legal/privacy" target="_blank" rel="noreferrer" style={{ color: "#9ca3af" }}>{lang === "el" ? "Απόρρητο" : "Privacy"}</a>
          {" · "}
          <a href="/api/public/legal/cookies" target="_blank" rel="noreferrer" style={{ color: "#9ca3af" }}>Cookies</a>
        </div>
      </div>
    </div>
  );
}
